import React, { Fragment, useCallback, useState, useEffect } from "react";
import { Card, CardBody } from 'reactstrap';

import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';
import GiftStatuses from '../../../../../enums/GiftStatuses';
import { completedColor } from '../../../../../config/calendar';

const localizer = momentLocalizer(moment);

export default function GiftsCalendar(props) {
    const {
        giverId,
        receiverId
    } = props;
    const { currentGroup } = useAuth();

    const [events, setEvents] = useState([]);

    const convertLabelDate = useCallback((system_date) => {
        if (system_date) {
            const month = parseInt(system_date.substring(4,6)) - 1;
            const date = new Date(
                system_date.substring(0,4),
                month,
                system_date.substring(6,8),
                system_date.substring(8,10),
                system_date.substring(10,12),
                0
            );
            return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        }
        return '';
    }, []);

    const getEvents = useCallback(() => {
        const convertDate = (system_date) => {
            if (system_date) {
                const month = parseInt(system_date.substring(4,6)) - 1;
                const date = new Date(
                    system_date.substring(0,4),
                    month,
                    system_date.substring(6,8),
                    system_date.substring(8,10),
                    system_date.substring(10,12),
                    0
                );
                return date;
            }
            return null;
        }

        if (giverId !== null && receiverId !== null) {
            api.post(`/ro.team.listScheduleGiftsForReceiver/${currentGroup.id}`, {
                giverId: giverId,
                receiverId: receiverId,
            })
                .then((response) => {
                    const events_remote = response.data;
                    if (events_remote && events_remote.length > 0) {
                        const calendar_events = [];
                        events_remote.map((event, index) => {
                            calendar_events.push({
                                id: index + 1,
                                title: `${convertLabelDate(event.date)} ${event.giver.name}`,
                                start: convertDate(event.date),
                                end: convertDate(event.date),
                                color: (event.status === GiftStatuses.COMPLETED) ? completedColor : undefined
                            });
                            return event;
                        });
                        setEvents(calendar_events);
                    }
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                });
        }
        
    }, [setEvents, currentGroup, giverId, receiverId, convertLabelDate]);

    useEffect(() => {
        if (true) {
            getEvents();
        }
    }, [getEvents]);

    return (
        <Fragment>
            <Card className="mb-3">
                <CardBody>
                    <Calendar
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        views={['month', 'day', 'agenda']}
                        eventPropGetter={event => {
                            if (event.color && event.color !== undefined) {
                                return { style: { backgroundColor: event.color } };
                            }
                        }}
                    />
                </CardBody>
            </Card>
        </Fragment>
    )
}
